<div class="d-flex flex-column justify-content-center align-items-center">
  <img [src]="image" [alt]="message"/>
  <h1 class="message">
    {{ message | translate}}
  </h1>
  <h3 class="info">
    {{info | translate}}
  </h3>
  <div class="d-flex flex-row justify-content-around align-items-center btns">
    @if (canRefresh) {
      <button class="button btn btn-outline-primary" (click)="refresh()">
        {{'error-refresh' | translate}}
      </button>
    }
    @if (canBack) {
      <button class="button btn btn-outline-primary" (click)="back()">
        {{'error-back' | translate}}
      </button>
    }
    <button class="button btn btn-outline-primary" (click)="home()">
      {{'error-home' | translate}}
    </button>
  </div>
</div>
